import { css } from '@emotion/react';

import { theme } from '@adflow/frontend/ui-theme';

export const dataTableStyles = {
	table: css({ width: '100%', tableLayout: 'fixed' }),
	tableWrap: css({ width: '100%', overflowY: 'auto', bottom: '4rem' }),
	tableHead: css({
		backgroundColor: theme.colors.background.tableHeader,
		position: 'sticky',
		top: '0px',
		zIndex: 1,
		height: '2rem',
		// Makes border stay with sticky header
		boxShadow: `0 1px ${theme.colors.input.border}`,
	}),
	tableRow: css({
		borderColor: theme.colors.input.border,
		color: theme.colors.text.primary,
		borderBottomWidth: '1px',
		maxHeight: '3.5rem',
		scrollMarginTop: '2rem',
	}),
	tableCell: css({
		borderColor: theme.colors.input.border,
		paddingLeft: '0.25rem',
		paddingRight: '0.25rem',
		paddingTop: '0.5rem',
		paddingBottom: '0.5rem',
		cursor: 'pointer',
		height: '3.5rem',
		maxHeight: '3.5rem',
		overflow: 'hidden',
		display: 'flex',
		alignItems: 'center',
	}),
	focusedTableRow: css({
		backgroundColor: theme.colors.background.form,
		position: 'relative',
		borderStyle: 'none',
	}),
	focusedTableRowArchived: css({ backgroundColor: '#EEE' }),
	sidebarRowStyle: css({ borderStyle: 'none' }),
};
